import { graphql } from "@cappelendamm/crystallize-types/catalogue/gql";
export const GetShapeBySku = graphql(`
  query ShapeBySku($skus: [String!]!) {
    productVariants(skus: $skus, language: "no-nb") {
      sku
      product {
        shapeIdentifier
        topics {
          path
        }
        clubCode: component(id: "klubbkode") {
          content {
            __typename
            ... on SelectionContent {
              options {
                key
              }
            }
          }
        }
      }
      price
    }
  }
`);
